/* @ngInject */
export default function EncodeURIComponentFilter() {
    return window.encodeURIComponent;
}
